import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  App: {
    height: "100vh",
    width: "100vw",
  },
});

export default useStyles;
